import { PublicClientApplication } from '@azure/msal-browser';

import { msalConfig } from './msalConfig';

// @ts-expect-error temporary solution
export const msalInstance = new PublicClientApplication(msalConfig);
